/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimesheetEntry } from './TimesheetEntry';
import {
    TimesheetEntryFromJSON,
    TimesheetEntryFromJSONTyped,
    TimesheetEntryToJSON,
    TimesheetEntryToJSONTyped,
} from './TimesheetEntry';

/**
 * 
 * @export
 * @interface RecordClockOutResponse
 */
export interface RecordClockOutResponse {
    /**
     * 
     * @type {TimesheetEntry}
     * @memberof RecordClockOutResponse
     */
    data: TimesheetEntry;
}

/**
 * Check if a given object implements the RecordClockOutResponse interface.
 */
export function instanceOfRecordClockOutResponse(value: object): value is RecordClockOutResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function RecordClockOutResponseFromJSON(json: any): RecordClockOutResponse {
    return RecordClockOutResponseFromJSONTyped(json, false);
}

export function RecordClockOutResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordClockOutResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TimesheetEntryFromJSON(json['data']),
    };
}

  export function RecordClockOutResponseToJSON(json: any): RecordClockOutResponse {
      return RecordClockOutResponseToJSONTyped(json, false);
  }

  export function RecordClockOutResponseToJSONTyped(value?: RecordClockOutResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TimesheetEntryToJSON(value['data']),
    };
}

